var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import styled from '../../../../styles/styled';
import { hideVisually, navigationItem } from '../../../../styles/style-mixins';
import { useClickEvent } from '../../../../hooks/useClickEvent';
import Body from '../../../Body';
import { useComponents } from '../../../ComponentsContext';
import { Skeleton } from '../../../Skeleton';
const anchorStyles = ({ theme }) => css `
  text-decoration: none;
  height: 100%;
  padding: 0 ${theme.spacings.mega};
  border-left: ${theme.borderWidth.kilo} solid var(--cui-border-divider);
`;
const UtilityAnchor = styled.a(navigationItem, anchorStyles);
const iconStyles = (theme) => css `
  flex-shrink: 0;
  width: ${theme.iconSizes.mega};
  height: ${theme.iconSizes.mega};

  ${theme.mq.kilo} {
    margin-right: ${theme.spacings.byte};
  }
`;
const labelStyles = ({ theme }) => css `
  ${theme.mq.untilKilo} {
    ${hideVisually()};
  }
`;
const UtilityLabel = styled(Body)(labelStyles);
function UtilityLink(_a) {
    var { icon: Icon, label, onClick, tracking } = _a, props = __rest(_a, ["icon", "label", "onClick", "tracking"]);
    const { Link } = useComponents();
    const handleClick = useClickEvent(onClick, tracking, 'utility-link');
    return (_jsxs(UtilityAnchor, Object.assign({}, props, { onClick: handleClick, as: props.href ? Link : 'button' }, { children: [_jsx(Skeleton, Object.assign({ css: iconStyles }, { children: _jsx(Icon, { role: "presentation", size: "24" }) })), _jsx(Skeleton, { children: _jsx(UtilityLabel, Object.assign({ variant: props.isActive ? 'highlight' : undefined, as: "span" }, { children: label })) })] })));
}
const UtilityLinksWrapper = styled.div `
  display: flex;
  align-items: center;
`;
export function UtilityLinks({ links }) {
    return (_jsx(UtilityLinksWrapper, { children: links.map((link) => (_jsx(UtilityLink, Object.assign({}, link), link.label))) }));
}
